<ng-content select="[napaIwoInput]"></ng-content>

<div class="napa-sm-vertical-divider"></div>

<ng-content select="[napaIwoSelect]"></ng-content>
